export default __webpack_public_path__ + "static/media/halonasoft-picturemark-d.d0c964f7.svg";